import { render, staticRenderFns } from "./MagazineListTable.vue?vue&type=template&id=33bd982c&scoped=true&lang=html"
import script from "./MagazineListTable.vue?vue&type=script&lang=js"
export * from "./MagazineListTable.vue?vue&type=script&lang=js"
import style0 from "./MagazineListTable.vue?vue&type=style&index=0&id=33bd982c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd982c",
  null
  
)

export default component.exports